<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item label="日期">

                <el-date-picker
                        v-model="formInline.today"
                        align="right"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="状态">
            <el-select v-model="formInline.status" filterable  placeholder="状态">
                <el-option label="未处理" value="0"></el-option>
                <el-option label="已处理" value="1"></el-option>
                <el-option label="全部" value="-1"></el-option>
            </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="getCardPlanLog">查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="CardPlanLog" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"
                  v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="planDetailedId" label="计划Id" width="70"></el-table-column>
            <el-table-column prop="batchName" label="奶卡批次" width="120"></el-table-column>
            <el-table-column prop="orderMainNo" label="订单号" width="120"></el-table-column>
            <el-table-column prop="createTime" label="发生时间" width="140"></el-table-column>
            <el-table-column prop="pickTime" :formatter="formatdate"  label="发货日期" width="90"></el-table-column>
            <el-table-column prop="message" label="错误信息" ></el-table-column>
            <el-table-column prop="status" :formatter="getStatusName"  label="状态" width="80" ></el-table-column>
            <el-table-column prop="promotionName" label="配送商品" width="160"></el-table-column>
            <el-table-column prop="quantity" label="数量" width="60"></el-table-column>
            <el-table-column prop="nickName" label="用户昵称" width="120"></el-table-column>
            <el-table-column prop="provinceName" label="省" width="90"></el-table-column>
            <el-table-column prop="cityName" label="市" width="90"></el-table-column>
            <el-table-column prop="areaName" label="区" width="90"></el-table-column>
            <el-table-column prop="address" label="地址" width="160"></el-table-column>

        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>

</template>
<script>
    //导入 HTTP请求方法
    import {getCardPlanLog} from '../../api/api';
    export default {
        data() {
            return {
                formInline: {
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                    today:new Date(),
                    status:"0"
                },
                showDialog: false,
                loading: true,
                CardPlanLog: [],// 订单退款失败列表
                pickerOptions: {
                    disabledDate(time) {
                        return false;//time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },

            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getCardPlanLog();
        },
        methods: {
            getCardPlanLog(){
                this.loading = true;
                getCardPlanLog(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.loading = false;
                        this.formInline.recordsTotal = res.data.value.total;
                        this.CardPlanLog = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            refundPay(){
             refundPay(this.formInline).then((res) => {
                 if(res.data.status==200){
                     this.$message({
                         showClose: true,
                         message: '成功',
                         type: 'success'
                     });
                 }else{
                     this.$message({
                         showClose: true,
                         message: res.data.message,
                         type: 'error'
                     });
                 }
             });
            },
            returnHistory(){
                window.history.back()
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getCardPlanLog();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getCardPlanLog();
            },
            formatdate(row, column, cellValue){
                if(cellValue==null){
                   return cellValue;
                }
                return cellValue.split(" ")[0];
            },
            getStatusName(row, column, cellValue) {
                if (cellValue == 1) {
                    return "已处理";
                } else if (cellValue ==0) {
                    return "未处理";
                } else if (cellValue == -1) {
                    return "全部";
                } else  {
                    return "未知";
                }
            },
        },

    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>


// WEBPACK FOOTER //
// src/views/order/cardOrderPlanLog.vue